import styled from "styled-components";

export const YSContainer = styled.div`
    width: 100%;
    padding-bottom: 40px;
    font-family: S-Core-Dream;

    .titleLb {
        color: #333;
        font-size: 24px;
        font-weight: 600;
    }
`;

/* ── Step 1: 이름 입력 ── */
export const NameInputWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    padding: 0 24px;

    .logo {
        font-size: 28px;
        font-weight: 700;
        color: #212529;
        margin-bottom: 8px;
    }

    .desc {
        font-size: 14px;
        color: #6c757d;
        margin-bottom: 32px;
    }

    input {
        width: 100%;
        max-width: 300px;
        height: 48px;
        padding: 0 16px;
        border: 1px solid #ced4da;
        border-radius: 10px;
        font-size: 16px;
        font-family: S-Core-Dream;
        text-align: center;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
        box-sizing: border-box;
        &:focus {
            border-color: #86b7fe;
            box-shadow: 0 0 0 3px rgba(13,110,253,0.15);
        }
        &::placeholder { color: #adb5bd; }
    }

    button {
        width: 100%;
        max-width: 300px;
        height: 48px;
        margin-top: 12px;
        background: #0d6efd;
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: #0b5ed7; }
        &:active { background: #0a58ca; }
    }
`;

/* ── Step 2: 폼 카드 ── */
export const YSFormCard = styled.div`
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    padding: 20px 16px;
    margin: 12px 12px 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);

    .formGroup {
        margin-bottom: 16px;

        label {
            display: block;
            font-size: 13px;
            font-weight: 600;
            color: #495057;
            margin-bottom: 6px;
        }

        input, select {
            width: 100%;
            height: 42px;
            padding: 0 12px;
            border: 1px solid #ced4da;
            border-radius: 8px;
            font-size: 14px;
            font-family: S-Core-Dream;
            background: #fff;
            box-sizing: border-box;
            outline: none;
            transition: border-color 0.2s, box-shadow 0.2s;
            &:focus {
                border-color: #86b7fe;
                box-shadow: 0 0 0 3px rgba(13,110,253,0.15);
            }
            &::placeholder { color: #adb5bd; }
        }

        input[readOnly] {
            background: #f8f9fa;
            cursor: pointer;
        }
    }

    .timeRow {
        display: flex;
        gap: 8px;

        select {
            flex: 1;
            min-width: 0;
            height: 42px;
            padding: 0 8px;
            border: 1px solid #ced4da;
            border-radius: 8px;
            font-size: 14px;
            font-family: S-Core-Dream;
            background: #fff;
            color: #495057;
            outline: none;
            cursor: pointer;
            box-sizing: border-box;
            &:focus { border-color: #86b7fe; }
        }
    }

    .carRow {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;

        label {
            font-size: 13px;
            font-weight: 600;
            color: #495057;
        }

        .toggle {
            position: relative;
            width: 48px;
            height: 26px;
            background: #ced4da;
            border-radius: 13px;
            cursor: pointer;
            transition: background 0.2s;

            &.on { background: #0d6efd; }

            &::after {
                content: '';
                position: absolute;
                top: 3px;
                left: 3px;
                width: 20px;
                height: 20px;
                background: #fff;
                border-radius: 50%;
                transition: transform 0.2s;
            }

            &.on::after {
                transform: translateX(22px);
            }
        }

        .seatsInput {
            width: 60px;
            height: 36px;
            padding: 0 8px;
            border: 1px solid #ced4da;
            border-radius: 8px;
            font-size: 14px;
            font-family: S-Core-Dream;
            text-align: center;
            outline: none;
            box-sizing: border-box;
            &:focus { border-color: #86b7fe; }
        }

        .seatsLb {
            font-size: 12px;
            color: #6c757d;
        }
    }

    .btnRow {
        display: flex;
        gap: 10px;
        margin-top: 20px;
    }

    .saveBtn {
        flex: 1;
        padding: 12px;
        background: #0d6efd;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: #0b5ed7; }
    }

    .listBtn {
        padding: 12px 16px;
        background: #fff;
        color: #495057;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
    }
`;

/* ── Step 3: 결과 ── */
export const YSResultWrap = styled.div`
    padding: 0 12px;

    .backBtn {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 6px 12px;
        margin-bottom: 16px;
        background: #fff;
        color: #6c757d;
        border: 1px solid #dee2e6;
        border-radius: 20px;
        font-size: 13px;
        font-family: S-Core-Dream;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            color: #495057;
            border-color: #adb5bd;
        }
        &::before {
            content: '✏️';
            font-size: 12px;
        }
    }

    .sectionTitle {
        font-size: 16px;
        font-weight: 700;
        color: #212529;
        margin: 20px 0 10px;
    }

    .sectionRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .assignGrid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 8px;
        margin-bottom: 8px;
    }

    .mapBtn {
        padding: 6px 12px;
        background: #fff;
        color: #0d6efd;
        border: 1px solid #0d6efd;
        border-radius: 6px;
        font-size: 12px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        margin-top: 10px;
        transition: all 0.2s;
        &:hover {
            background: #0d6efd;
            color: #fff;
        }
    }

    .tabRow {
        display: flex;
        gap: 8px;
        margin-bottom: 16px;
    }

    .tab {
        flex: 1;
        padding: 10px;
        background: #fff;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 13px;
        font-family: S-Core-Dream;
        font-weight: 600;
        color: #495057;
        cursor: pointer;
        text-align: center;
        transition: all 0.2s;

        &.active {
            background: #0d6efd;
            color: #fff;
            border-color: #0d6efd;
        }
    }

    .participantList {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 16px;
    }

    .participantChip {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 12px;
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 20px;
        font-size: 14px;
        color: #212529;

        .timeMark {
            font-size: 10px;
            color: #6c757d;
        }

        .carMark {
            font-size: 10px;
            background: #e8f5e9;
            color: #2e7d32;
            padding: 1px 5px;
            border-radius: 4px;
            font-weight: 600;
        }

        .chipDel {
            width: 18px;
            height: 18px;
            border: none;
            background: #eee;
            border-radius: 50%;
            font-size: 11px;
            color: #999;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover { background: #dc3545; color: #fff; }
        }
    }

    .subTitle {
        font-size: 13px;
        font-weight: 600;
        color: #6c757d;
        margin: 10px 0 6px;
    }

    .unassignedList {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 12px;
    }

    .unassignedName {
        padding: 6px 12px;
        background: #f8f9fa;
        border: 1px dashed #adb5bd;
        border-radius: 20px;
        font-size: 13px;
        color: #6c757d;
    }

    .overviewBtnRow {
        display: flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .overviewBtn {
        flex: 1;
        padding: 10px;
        background: #fff;
        color: #495057;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 14px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            background: #f8f9fa;
            border-color: #0d6efd;
            color: #0d6efd;
        }
    }

    .assignBtn {
        width: 100%;
        padding: 12px;
        margin-bottom: 16px;
        background: #198754;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: #157347; }
        &:disabled { background: #6c757d; cursor: wait; }
    }

    .emptyMsg {
        text-align: center;
        color: #6c757d;
        font-size: 14px;
        padding: 40px 0;
    }
`;

/* ── 참여자 카드 ── */
export const ParticipantCard = styled.div`
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);

    .info {
        flex: 1;
        min-width: 0;
    }

    .name {
        font-size: 15px;
        font-weight: 600;
        color: #212529;
        margin-bottom: 3px;
    }

    .meta {
        font-size: 12px;
        color: #6c757d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .carBadge {
        padding: 4px 8px;
        background: #e8f5e9;
        color: #2e7d32;
        border-radius: 6px;
        font-size: 11px;
        font-weight: 600;
        margin-left: 8px;
        white-space: nowrap;
    }

    .delBtn {
        width: 28px;
        height: 28px;
        min-width: 28px;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        background: #fff;
        color: #dc3545;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        transition: background 0.15s;
        &:hover {
            background: #dc3545;
            color: #fff;
            border-color: #dc3545;
        }
    }
`;

/* ── 배정 결과 카드 ── */
export const AssignCard = styled.div`
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    padding: 12px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);

    &.over {
        border-color: #ffc107;
        background: #fffde7;
    }

    .driverRow {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px solid #f0f0f0;
    }

    .driverIcon {
        width: 22px;
        height: 22px;
        background: #0d6efd;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        margin-right: 6px;
    }

    .driverName {
        font-size: 13px;
        font-weight: 600;
        color: #212529;
    }

    .routeBtn {
        margin-left: auto;
        padding: 3px 8px;
        background: #fff;
        color: #0d6efd;
        border: 1px solid #0d6efd;
        border-radius: 5px;
        font-size: 10px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        &:hover { background: #0d6efd; color: #fff; }
    }

    .riderList {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .riderItem {
        display: flex;
        align-items: center;
        padding: 2px 0;
        font-size: 12px;
        color: #495057;

        &::before {
            content: '';
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #adb5bd;
            border-radius: 50%;
            margin-right: 6px;
            margin-left: 6px;
        }
    }

    .overWarning {
        margin-top: 6px;
        padding: 4px 8px;
        background: #fff3cd;
        color: #856404;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 600;
    }

    .noRider {
        font-size: 11px;
        color: #adb5bd;
        padding: 2px 0;
    }
`;

/* ── 경로 지도 ── */
export const YSRouteMapWrap = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 300;
    display: flex;
    flex-direction: column;

    .mapHeader {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #dee2e6;
        background: #fff;
    }

    .mapTitle {
        font-size: 16px;
        font-weight: 700;
        color: #212529;
        font-family: S-Core-Dream;
    }

    .mapTabs {
        display: flex;
        gap: 4px;
        margin-left: auto;
        margin-right: 12px;

        button {
            padding: 6px 14px;
            border: 1px solid #ced4da;
            border-radius: 6px;
            background: #fff;
            font-size: 13px;
            font-family: S-Core-Dream;
            color: #495057;
            cursor: pointer;

            &.active {
                background: #0d6efd;
                color: #fff;
                border-color: #0d6efd;
            }
        }
    }

    .closeBtn {
        cursor: pointer;
        min-width: 24px;
        margin-left: auto;
    }

    .mapLoading {
        position: absolute;
        top: 60px;
        left: 0;
        width: 100%;
        padding: 10px;
        text-align: center;
        background: rgba(255,255,255,0.9);
        font-size: 14px;
        color: #6c757d;
        font-family: S-Core-Dream;
        z-index: 10;
    }

    .routeMap {
        flex: 1;
    }

    .routeInfoBar {
        display: flex;
        gap: 16px;
        justify-content: center;
        padding: 10px 16px;
        border-top: 1px solid #dee2e6;
        background: #fff;
        font-family: S-Core-Dream;
        font-size: 14px;
        font-weight: 600;
        color: #495057;
    }

    .legend {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 10px 16px;
        border-top: 1px solid #dee2e6;
        background: #fff;
    }

    .legendItem {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #495057;
        font-family: S-Core-Dream;
    }

    .legendDot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
`;
